<div class="add-partner-container">
    <h2>Partner felvétele</h2>
    <div class="add-partner-form-container">
        <form [formGroup]="addPartner" (ngSubmit)="onSave()">
            <div class="add-partner-name">
                <label for="add-partner-name">Partner neve:</label>
                <input formControlName="partnerName" id="add-partner-name" name="add-partner-name" type="text" />
            </div>
            @if (!onSalePeriodOnlyModeEnabled) {
                <div class="btn-container">
                    <button class="btn-checkbox" type="button" [class.is-active]="commissionNeeded" (click)="addParnterCommission()">
                        <input style="pointer-events: none" type="checkbox" [checked]="commissionNeeded" />
                        Jutalék hozzáadása
                    </button>
                </div>
            }
            @if (commissionNeeded) {
                <div class="add-partner-details" id="add-partner-commission">
                    <h3>Jutalék felvétele:</h3>
                    <label for="add-partner-product-for-commission">Termék megnevezése:</label>
                    <select
                        formControlName="productIdForCommission"
                        id="add-partner-product-for-commission"
                        name="add-partner-product-for-commission"
                    >
                        <option [ngValue]="null"></option>
                        @for (product of products; track product; let i = $index) {
                            <option [ngValue]="product.id">{{ product.author }}: {{ product.title }}</option>
                        }
                    </select>
                    <div class="add-partner-commission">
                        <label for="add-partner-commission">Jutalék megnevezése:</label>
                        <input
                            formControlName="partnerCommissionName"
                            id="add-partner-commission"
                            name="add-partner-commission"
                            type="text"
                        />
                    </div>
                    <div class="add-partner-commission-percentage">
                        <label for="add-partner-commission-percentage">Jutalék:</label>
                        <input
                            formControlName="partnerCommissionPercentage"
                            id="add-partner-commission-percentage"
                            name="add-partner-commission-percentage"
                            type="number"
                        />
                    </div>
                    <div>
                        <label for="add-partner-commission-start-date">Kezdeti dátum:</label>
                        <input
                            formControlName="partnerCommissionStartDate"
                            id="add-partner-commission-start-date"
                            name="add-partner-commission-start-date"
                            type="date"
                        />
                    </div>
                </div>
            }
            @if (!commissionOnlyModeEnabled) {
                <div class="btn-container">
                    <button class="btn-checkbox" type="button" [class.is-active]="onSalePeriodNeeded" (click)="addParnterOnSalePeriod()">
                        <input style="pointer-events: none" type="checkbox" [checked]="onSalePeriodNeeded" />
                        Akció hozzáadása
                    </button>
                </div>
            }
            @if (onSalePeriodNeeded) {
                <div class="add-partner-details" id="add-partner-on-sale-period">
                    <h3>Akció felvétele</h3>
                    <label for="add-partner-product-for-on-sale-period">Termék megnevezése:</label>
                    <select
                        formControlName="productIdForOnSalePeriod"
                        id="add-partner-product-for-on-sale-period"
                        name="add-partner-product-for-on-sale-period"
                    >
                        <option [ngValue]="null"></option>
                        @for (product of products; track product; let i = $index) {
                            <div>
                                <option [ngValue]="product.id">{{ product.author }}: {{ product.title }}</option>
                            </div>
                        }
                    </select>
                    <div class="add-partner-on-sale-period">
                        <label for="add-partner-on-sale-period">Akció megnevezése:</label>
                        <input
                            formControlName="partnerOnSalePeriodName"
                            id="add-partner-on-sale-period"
                            name="add-partner-on-sale-period"
                            type="text"
                        />
                    </div>
                    <div class="add-partner-on-sale-period-percentage">
                        <label for="add-partner-on-sale-period-percentage">Akció:</label>
                        <input
                            formControlName="partnerOnSalePeriodPercentage"
                            id="add-partner-on-sale-period-percentage"
                            name="add-partner-on-sale-period-percentage"
                            type="number"
                        />
                    </div>
                    <div>
                        <label for="add-partner-on-sale-period-start-date">Kezdeti dátum:</label>
                        <input
                            formControlName="partnerOnSalePeriodStartDate"
                            id="add-partner-on-sale-period-start-date"
                            name="add-partner-on-sale-period-start-date"
                            type="date"
                        />
                    </div>
                    <div>
                        <label for="add-partner-on-sale-period-end-date">Vég dátum:</label>
                        <input
                            formControlName="partnerOnSalePeriodEndDate"
                            id="add-partner-on-sale-period-end-date"
                            name="add-partner-on-sale-period-end-date"
                            type="date"
                        />
                    </div>
                </div>
            }
            <div class="btn-container">
                <button class="btn-primary" id="btn-save" type="submit">
                    <mat-icon>save</mat-icon>
                    Mentés
                </button>
                <button class="btn-primary" id="btn-cancel" type="button" (click)="onCancel()">
                    <mat-icon>cancel</mat-icon>
                    Mégse
                </button>
            </div>
        </form>
    </div>
</div>
